export default "__VITE_ASSET__50f34737__"